import * as Sentry from "@sentry/react";

if (process.env.REACT_APP_WEB_ENV === 'production') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [],
    ignoreErrors: [/^Non-Error promise rejection captured with value: Object/],
  });
}